const colors = {
  // Cores principais baseadas na logo JUMA DELIVERY (invertidas)
  primary: '#F97316', // Laranja da logo ("DELIVERY") - agora primária
  primaryLight: '#FB923C', // Laranja mais claro para hover/estados
  primaryDark: '#EA580C', // Laranja mais escuro para textos/contraste
  secondary: '#1E40AF', // Azul principal da logo (ícone e "JUMA") - agora secundária
  secondaryLight: '#3B82F6', // Azul mais claro
  secondaryDark: '#1E3A8A', // Azul mais escuro

  // Cores neutras
  inheritDefault1: '#fefefe',
  inheritDefault2: '#f8f9ff',
  second: '#070919', // Preto para textos

  // Cores de apoio (mantidas para compatibilidade)
  indigo: '#6366F1', // Azul índigo harmonioso
  purple: '#8B5CF6', // Roxo suave
  pink: '#EC4899', // Rosa vibrante
  red: '#EF4444', // Vermelho para erros
  orange: '#F97316', // Laranja (mesmo da secondary)
  yellow: '#F59E0B', // Amarelo para avisos
  green: '#10B981', // Verde para sucesso
  teal: '#14B8A6', // Verde-azulado
  cyan: '#06B6D4' // Ciano para informações
};

export default colors;
